export class PageInitializer {
  private static instance: PageInitializer | null = null;
  private _isInitialized: boolean = false;

  private constructor() {
    // private constructorでnewの使用を防ぐ
  }

  public static getInstance(): PageInitializer {
    if (!PageInitializer.instance) {
      PageInitializer.instance = new PageInitializer();
    }
    return PageInitializer.instance;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  public ready(): Promise<void> {
    if (this._isInitialized) {
      return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () =>
          this.handleReady(resolve)
        );
      } else {
        this.handleReady(resolve);
      }
    });
  }

  private handleReady(resolve: () => void): void {
    if (document.fonts && 'ready' in document.fonts) {
      // タイムアウト用のIDを保持する変数
      let timeoutId: number;

      // タイムアウト処理
      const timeoutPromise = new Promise<void>((timeoutResolve) => {
        timeoutId = window.setTimeout(() => {
          console.warn('フォント読み込みがタイムアウトしました（1000ms）');
          timeoutResolve();
        }, 1000);
      });

      // フォント読み込み処理
      const fontLoadingPromise = Promise.all([
        Promise.resolve(),
        document.fonts.ready,
      ]).then(() => {
        // フォント読み込みが先に完了したらタイムアウトをクリア
        window.clearTimeout(timeoutId);
        return;
      });

      // フォント読み込みとタイムアウトを競争させる
      Promise.race([fontLoadingPromise, timeoutPromise])
        .then(() => {
          this.completeInitialization();
          resolve();
        })
        .catch((error) => {
          console.error('フォント読み込み中にエラーが発生しました:', error);
          // エラー時もタイムアウトをクリアしておく
          window.clearTimeout(timeoutId);
          this.completeInitialization();
          resolve();
        });
    } else {
      this.completeInitialization();
      resolve();
    }
  }

  private completeInitialization(): void {
    if (!this._isInitialized) {
      this._isInitialized = true;
    }
  }
}

export default PageInitializer;
